var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"board-title",attrs:{"loading":_vm.loading,"value":_vm.title,"color":"success","outlined":"","hide-details":"","dense":"","label":"Edit Title"},on:{"change":_vm.changeBoardName}})}
var staticRenderFns = []

export { render, staticRenderFns }